import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in.component';
import { NotAuthenticatedGuard } from '../../core/guards/not-authenticated.guard';

const routes: Routes = [
  {
    path: '',
    component: SignInComponent,
    canActivate: [NotAuthenticatedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignInRoutingModule { }
